export const EmailOptions = {
  required: 'Ange en e-mail',
  minLength: {
    value: 3,
    message: 'Ogiltig e-mail',
  },
  maxLength: {
    value: 60,
    message: 'Ogiltig e-mail',
  },
  pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: 'Ogiltig e-mail' },
}

export const PhoneNumberOptions = {
  required: 'Ange ett telefonnummer',
  minLength: {
    value: 8,
    message: 'Ogiltigt telefonnummer',
  },
  maxLength: { value: 16, message: 'Ogiltigt telefonnummer' },
  pattern: {
    value: new RegExp('^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$'),
    message: 'Ogiltigt telefonnummer',
  },
}
